export default __webpack_public_path__ + "static/media/team7.cfed08e2.png";